import React from "react";
import {useTranslation} from "react-i18next";
import {usePropState} from "../utils";
import Icon from "../Icon";
import styled from "styled-components";
import {COLORS as COLOR} from "../theme";

const SearchDiv = styled.div`
  width: 250px;
  display: inline-block;
  position: relative;
  white-space: normal;
  input {
    padding-left: 30px;
    height: 34px;
  }
  svg {
    font-size: 18px;
    position: absolute;
    top: 8px;
    left: 7px;
    color: ${COLOR.midGrey};
  }
`

function TableSearch({onChange, ready, ...props}) {
  const { t } = useTranslation();
  const [value] = usePropState(props.value)

  return (
    <SearchDiv style={props.style}>
      <Icon icon={"search"} />
      <input
        type="search"
        className="form-control form-control-sm"
        placeholder={t('table.search')}
        value={value || ""}
        onChange={e => onChange(e.target.value)}>
      </input>
    </SearchDiv>
  )
}

export default TableSearch


export function TableSearchRow(props) {
  return (
    <div style={{marginBottom: "30px", width: "100%"}}>
      <TableSearch {...props}/>
    </div>
  )
}
